module.exports =  {
    PORT: process.env.PORT || 8000,
    // API_ENDPOINT: "http://localhost:8000/api",
    API_ENDPOINT: 'https://polar-caverns-65343.herokuapp.com/api',
    TOKEN_KEY: 'neighborhood-client-auth-token'
}